import React from 'react';
import Button from 'shared/ui/Button';
import CancelButton from 'shared/ui/CancelButton';
import {
  Wrapper, Title, Footer, WarningIcon
} from './styled';
import useKeyPress from 'Hooks/useKeyPress';

const Warning = ({
  title, children, onAccept, onClose
}) => {
  useKeyPress(() => {
    if (onClose) onClose();
  }, ['Escape']);

  useKeyPress(() => {
    if (onAccept) onAccept();
  }, ['Enter']);
  return (
    <Wrapper>
      <Title>
        <WarningIcon />
        {title}
      </Title>
      { children }
      <Footer>
        { onClose ? <CancelButton onClick={ onClose }>Close</CancelButton> : null }
        { onAccept ? <Button onClick={ onAccept }>Accept</Button> : null }
      </Footer>
    </Wrapper>
  );
};
export default Warning;
